import { useEffect, useState } from "react";
import { MoneyFormat } from "./MoneyFormat";
import * as React from "react";

export function netGrossFieldName() {
    return localStorage.getItem('net_gross') === 'true' ? 'Brutto' : 'Netto';
}

export function netGrossField(prefix = '', suffix = 'value') {
    return localStorage.getItem('net_gross') === 'true' ? prefix + 'gross_' + suffix : prefix + 'net_' + suffix;
}

export function netGrossColumn(prefix = '', suffix = 'value', fieldNamePrefix = '', fieldNameSuffix = '') {
    return {
        key: netGrossField(prefix, suffix),
        name: fieldNamePrefix + netGrossFieldName() + fieldNameSuffix,
        ariaLabel: fieldNamePrefix + netGrossFieldName() + fieldNameSuffix,
        fieldName: netGrossField(prefix, suffix),
        isResizable: true,
        className: 'money-field',
        onRender: (item) => (<span title={`VAT ${item.vat}%`}>{MoneyFormat(item[netGrossField(prefix, suffix)])}</span>)
    }
}

export function useNetGross() {
    const [netGross, setNetGross] = useState(localStorage.getItem('net_gross'));
    useEffect(() => {
        function checkNetGross() {
            const netGrossToggle = localStorage.getItem('net_gross')

            if (netGrossToggle) {
                setNetGross(netGrossToggle);
            }
        }

        window.addEventListener('netGross', checkNetGross)

        return () => {
            window.removeEventListener('netGross', checkNetGross)
        }
    }, []);
    return netGross;
}